import React, { useEffect, useState } from 'react'
import styles from './style.module.sass'
import { useIsMobile } from 'hooks/useIsMobile'
import MainLayout from 'newComponents/Layout/MainLayout'
import HeaderSubMenu from 'newComponents/HeaderSubMenu'

const benficiosData = {
    title: {
        title: 'BENEFICIOS',
        col1: 'Tarjeta Black',
        col2: 'Tarjeta Gold'
    },
    content: [
        {
            beneficio: '<b>Sin costo por apertura</b> o anualidad',
            black: true,
            gold: true
        },{
            beneficio: 'Siempre las mejores condiciones de compra al pagar con tu Crédito',
            black: 'Hasta 25%',
            gold: 'Hasta 20%'
        },{
            beneficio: '<b>10% de descuento</b> en Restaurantes y Pastelerías (Sanborns y Sanborns café)',
            black: 'Hasta 15% con crédito revolvente',
            gold: 'Hasta 15% con crédito revolvente'
        },{
            beneficio: 'Descuentos en prestigiados establecimientos a nivel nacional presentando tu tarjeta',
            black: true,
            gold: true
        },{
            beneficio: 'Puntos en todas tus compras con crédito revolvente. Al activar tu tarjeta recibe 100 puntos de bienvenida',
            black: true,
            gold: true
        },{
            beneficio: '25 días después de su fecha de corte para liquidar el saldo de la cuenta, sin cargo por intereses',
            black: true,
            gold: true
        },{
            beneficio: 'Pago de la tarjeta en cualquier registradora de las tiendas y a través de la página de Internet',
            black: true,
            gold: true
        },{
            beneficio: 'Plan tarifario Telcel con cargo a la tarjeta',
            black: true,
            gold: true
        },{
            beneficio: 'Contratación de seguro para auto con cargo mensual (Autotal Inbursa)',
            black: true,
            gold: true
        },{
            beneficio: 'Contratación de seguro personal con cargo mensual',
            black: 'Proteccion Personal Sears o Protección Personal Sears Plus, primeros 2 meses gratis',
            gold: 'Proteccion Personal Sears o Protección Personal Sears Plus, primeros 2 meses gratis'
        },{
            beneficio: 'Contratación de seguro Membresía Medicall Home con cargo mensual',
            black: true,
            gold: true
        },{
            beneficio: 'Aceptada en:',
            black: null,
            gold: null
        },{
            beneficio: 'Sears.com.mx',
            black: true,
            gold: true
        },{
            beneficio: 'Sanborns',
            black: true,
            gold: true
        },{
            beneficio: 'Descuento en viajes Hasta 25% de descuento en Hoteles de grupo Ostar',
            black: true,
            gold: true
        },{
            beneficio: 'Tarjetas adicionales sin costo',
            black: true,
            gold: true
        },{
            beneficio: 'Descuento en el mes de tu cumpleaños **',
            black: true,
            gold: true
        },
    ]
    
}

const formaPago = {
    title: {
        title: 'FORMAS DE PAGO',
        col1: 'Tarjeta Black',
        col2: 'Tarjeta Gold'
    },
    content: [
        {
            beneficio: 'Cuenta Revolvente',
            black: true,
            gold: true
        },{
            beneficio: 'Mensualidades sin Intereses',
            black: true,
            gold: true
        },{
            beneficio: 'Mensualidades Fijas',
            black: true,
            gold: true
        },{
            beneficio: 'Cargo Demorado',
            black: true,
            gold: true
        },{
            beneficio: 'Descuento Adicional pagando con la Cuenta Revolvente',
            black: true,
            gold: true
        }
    ]
}

const ColumnBeneficio = (props) => {
    const {beneficio} = props
    return(
        <td className={styles?.row1}>
            <div className={styles?.colDescrip} dangerouslySetInnerHTML={{__html: beneficio }}></div>
        </td>
    )
}

const ColumnBlack = (props) => {
    const {black} = props
    const [content, setContent] = useState(null)
    useEffect(()=>{
        if(typeof black === 'boolean'){
            if(black === true){
                setContent(<div className={styles?.colBlack}>
                    <span className={styles?.ico_bene_true}></span>
                </div>)
            }else{
                setContent(<div className={styles?.colBlack}>
                    <span className={styles?.ico_bene_false}></span>
                </div>)
            }
        }
        else if(typeof black === 'string'){
            setContent(<div className={styles?.colBlack} dangerouslySetInnerHTML={{__html: black }}></div>)
        }else{
            setContent(<div className={styles?.colBlack}></div>)
        }
    },[black])
    return(
        <td className={styles?.row2}>{content}</td>
    )
}
const ColumnGold = (props) => {
    const {gold} = props
    const [content, setContent] = useState(null)
    useEffect(()=>{
        if(typeof gold === 'boolean'){
            if(gold === true){
                setContent(<div className={styles?.colGold}>
                    <span className={styles?.ico_bene_true}></span>
                </div>)
            }else{
                setContent(<div className={styles?.colGold}>
                    <span className={styles?.ico_bene_false}></span>
                </div>)
            }
        }
        else if(typeof gold === 'string'){
            setContent(<div className={styles?.colGold} dangerouslySetInnerHTML={{__html: gold }}></div>)
        }else{
            setContent(<div className={styles?.colGold}></div>)
        }
    },[gold])
    return(
        <td className={styles?.row3}>{content}</td>
    )
}


const TitleAndReturn = () => {

    const returnBtn = () => {
        window.history.back()
    }

    return(
        <section className={`${styles?.titlePage} ${styles?.contanierSection}`}>
            <span className={styles?.return} onClick={returnBtn}>Regresar</span>
            <h1>BENEFICIOS DE TUS TARJETAS SEARS</h1>
        </section>
    )
} 

const SectionCards = (props) => {

    const {
        response
    } = props

    const [ title, setTitle] = useState()
    const [ content, setContent] = useState()

    useEffect(()=>{
        if(response){
            setTitle(response?.title)
            setContent(response?.content)
        }
    },[response])

    return(
        <section className={`${styles?.CardsDescriptionPage} ${styles?.contanierSection}`}>
            <table className={styles?.tableCards}>
                <tbody>
                    <tr className={styles?.rowContent}>            
                        <td className={styles?.row1}>
                            <div className={styles?.titlesRows}></div> 
                        </td>
                        <td className={styles?.row2}>
                            <div className={styles?.titlesRows}>
                                <div className={styles?.colBlack}>
                                    <div className={styles?.cardBlack}></div>
                                </div> 
                            </div>
                        </td>
                        <td className={styles?.row3}>
                            <div className={styles?.titlesRows}>
                                <div className={styles?.colGold}>
                                    <div className={styles?.cardGold}></div>
                                </div>    
                            </div>
                        </td>
                    </tr>

                    {title
                        ?
                            <tr className={styles?.rowContent}>            
                                <td className={styles?.row1}>
                                    <div className={styles?.titlesRows}>
                                        <div className={styles?.colDescrip}>{title?.title}</div>
                                    </div> 
                                </td>
                                <td className={styles?.row2}>
                                    <div className={styles?.titlesRows}>
                                        <div className={styles?.colBlack}>{title?.col1}</div>
                                    </div>
                                </td>
                                <td className={styles?.row3}>
                                    <div className={styles?.titlesRows}>
                                        <div className={styles?.colGold}>{title?.col2}</div>
                                    </div>
                                </td>
                            </tr>
                        : null
                    }
                    {content
                        ?
                            content?.map((resp, index) => {

                                return(
                                    <tr key={index} className={styles?.rowContent}> 
                                        <ColumnBeneficio beneficio={resp?.beneficio} />
                                        <ColumnBlack black={resp?.black} />
                                        <ColumnGold gold={resp?.gold} />
                                    </tr>
                                )
                            })
                        : null
                    }
                </tbody>
            </table>
        </section>
    )
}


const LandingBeneficios = () => {


    const { isMobile } = useIsMobile()

    return(
        <MainLayout>
            <main className={isMobile === 'desktop' ? styles?.mainDesktop : styles?.mainMobile}>
                <HeaderSubMenu />
                <TitleAndReturn />
                <SectionCards response={benficiosData} />
                <SectionCards response={formaPago} />
                
            </main>
        </MainLayout>
    )
}


export default LandingBeneficios